import React, { SVGProps } from 'react';

export default ({ ...props }: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 38 41" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"><path d="m3.623 18.682v20.818h11.528v-12.267h7.359v12.267h11.528v-20.818" transform="translate(0 .627)" /><path d="m37.161 20.638-18.331-13.565-18.33 13.565v-6.199l18.33-13.566 18.331 13.566z" transform="translate(0 .627)" /><path d="m7.184 26.205h4.749v-4.749h-4.749zm18.543 0h4.749v-4.749h-4.749z" /></g>
  </svg>
);
